module.exports = __webpack_public_path__ + "static/media/cart-icon.aca78b31.svg";